const SITE = "https://vetrodesignitalia.it";
const DEFAULT_OG = `${SITE}/og-image.jpg`;

// React 19 natively hoists <title>, <meta> and <link> to <head>,
// so no external head-management library is needed.
export const Seo = ({ title, description, path = "/", jsonLd, noindex, image, type = "website" }) => {
  const url = `${SITE}${path}`;
  const ogImage = image || DEFAULT_OG;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />
      <meta property="og:site_name" content="VETRO DESIGN ITALIA" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
};
